import { j as s } from "../../jsx-runtime-Wav_3Wde.js";
import o from "../BaseIcon.mjs";
const t = (c) => /* @__PURE__ */ s.jsx("svg", {
  viewBox: "0 0 48 48",
  "aria-label": "Thumbs up",
  ...c,
  children: /* @__PURE__ */ s.jsx("path", {
    d: "M41.23,31.41c1.54-0.28,2.27-1.21,2.27-2.53c0-1.16-0.72-2.07-1.74-2.47c-0.14-0.06-0.14-0.19,0-0.23 c1.26-0.28,2.24-1.26,2.24-2.6c0-1.55-1.26-2.81-2.81-2.81L28.6,20.78c0.54-1.79,2.71-3.18,3.08-7.3c0.15-2.48,0.12-4.97-1.23-6.62 c-0.67-0.82-1.63-1.05-2.54-0.71c-0.46,0.17-0.82,0.73-1.02,1.39c-0.2,0.66-0.7,2.81-0.86,3.72c-0.16,0.91-0.42,2.24-1.21,2.91 c-1.49,1.27-8.85,7.48-10.18,8.57s-2.48,1.08-2.48,1.08L4.4,23.81c-0.22,0-0.4,0.18-0.4,0.4v16.21c0,0.22,0.18,0.4,0.4,0.4 c0,0,6.91,0,9.6,0c2.69,0,9.28,1.17,11.96,1.17c2.68,0,13.94,0,13.94,0l0-0.02c1.42-0.09,2.6-1.3,2.6-2.86 c0-1.11-0.48-1.96-1.43-2.19c-0.18-0.06-0.16-0.15,0-0.23c1.11-0.26,1.93-1.34,1.93-2.55c0-1.17-0.44-2.1-1.77-2.43 C41.04,31.66,41.04,31.45,41.23,31.41z"
  })
}), p = (c) => /* @__PURE__ */ s.jsx(o, {
  IconSvg: t,
  ...c
});
export {
  p as default
};
